import React from 'react';
import XCard from '../../components/Cards/XCard'
import YCard from '../../components/Cards/YCard'
import JobTrendCard from '../../components/Cards/JobTrendCard';
import JobStatusCard from '../../components/Cards/JobStatusCard';
import serviceProvider from "../../assets/serviceProvider.png";
import homeOwner from "../../assets/homeOwner.png";

const Dashboard = () => {
    let jobs = <div><p>Number of</p>
        <p style={{ padding: '5px 0px 5px 25px' }}>Jobs</p>
        <p> to be settled</p></div>;

    let services = <div><p>Number of</p>
        <p style={{ margin: '5px -15px' }}>Service Providers</p>
        <p> to be settled</p></div>;


    return (
        <div style={{ marginTop: '40px' }}>
            <div style={{ display: 'flex' }}>
                <JobTrendCard />
                <JobStatusCard />
            </div>
            <div style={{ display: 'flex', marginTop: '30px', justifyContent:'space-between'}}>
                <div style={{ display: 'flex', flexDirection: 'column', width: '47.5%' }}>
                    <XCard num={123} name="Service Providers" color="#E5F5E9" border="#44983C" image={serviceProvider} />
                    <XCard num={34} name="Home Owners" color="#F0F8F9" border="#3C8C9E" image={homeOwner}/>
                </div>
                <div style={{ display: 'flex', width: '47.5%', justifyContent:'space-between', marginRight: '26px' }}>
                 <YCard num={30} name={jobs} color="#F7E5E8" />
                 <YCard num={3} name={services} color="#FFEFD9" />
                </div>
            </div>
        </div>

    );
};

export default Dashboard;